(function() {
  define('tlhServicesFroala',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesFroala', []).factory('TlhFroalaService', [
      '$http', function($http) {
        var factory;
        factory = {};
        factory.completeConfigWithDefaultValues = function(config) {
          if (config.language == null) {
            config.language = 'fr';
          }
          if (config.placeholderText == null) {
            config.placeholderText = 'Saisissez votre texte ici...';
          }
          if (config.pastePlain == null) {
            config.pastePlain = true;
          }
          if (config.saveInterval == null) {
            config.saveInterval = 0;
          }
          if (config.tabSpaces == null) {
            config.tabSpaces = 4;
          }
          if (config.charCounterCount == null) {
            config.charCounterCount = false;
          }
          if (config.fileUseSelectedText == null) {
            config.fileUseSelectedText = true;
          }
          if (config.linkEditButtons == null) {
            config.linkEditButtons = ['linkOpen', 'linkEdit', 'linkRemove'];
          }
          if (config.linkAttributes == null) {
            config.linkAttributes = {
              title: 'Infobulle'
            };
          }
          return config.imageEditButtons != null ? config.imageEditButtons : config.imageEditButtons = ['imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '|', 'imageDisplay', 'imageAlt', 'imageSize'];
        };
        factory.completeConfigWithServerValues = function(config) {
          return new Promise(function(resolve, reject) {
            return $http.get('/api/froala/config', {
              cache: true
            }).then(function(response) {
              var uploadConfig;
              config.key = response.data.key;
              uploadConfig = response.data.config;
              config.fileMaxSize = uploadConfig.maxFileSize;
              config.fileUploadToS3 = {
                bucket: uploadConfig.bucket,
                region: uploadConfig.endpoint,
                keyStart: '',
                params: {
                  acl: uploadConfig.acl,
                  'x-amz-credential': uploadConfig.credential,
                  'x-amz-algorithm': uploadConfig.algorithm,
                  'x-amz-date': uploadConfig.date,
                  'x-amz-expires': uploadConfig.expires,
                  'x-amz-signature': uploadConfig.signature,
                  policy: uploadConfig.policy
                }
              };
              return resolve(config);
            })["catch"](function(error) {
              console.error(error);
              config.fileUploadURL = '';
              return resolve(config);
            });
          });
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=froala.js.map
;
